'use strict';

export class Dropdown {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		this.$root = jQuery(`body .js-${this.id}`);
		this.$list = this.$root.find(`.js-${this.id}_list`);
		this.$selected = this.$root.find(`.js-${this.id}_selected`);
		this.$options = this.$list.find(`.js-${this.id}_option`);
	}
	re_init() {
		this.$root = jQuery(`body .js-${this.id}`);
		this.init();
	}
	init() {
		this.$root.each((index, element) => {
			if (!jQuery(element).data('initialized')) {
				this.$root = jQuery(element);
				this.$list = this.$root.find(`.js-${this.id}_list`);
				this.$selected = this.$root.find(`.js-${this.id}_selected`);
				this.$options = this.$list.find(`.js-${this.id}_option`);
				this.add_events();
				jQuery(element).data('initialized', true);
			}
			
		})
	}
	close_all(event) {
		// it is a navigation do notting
		if (jQuery(event.relatedTarget).attr('href')) {
			return;
		}
		yalwa.basics.bem_modifier(this.$list, 'active', 'remove');
		if (this.$list.find(`.js-${this.id}_option`).length) {
			yalwa.basics.bem_modifier(this.$list.find(`.js-${this.id}_option`), 'active', 'remove');
		}
		if (this.$selected.find(`.js-${this.id}_option`).length) {
			yalwa.basics.bem_modifier(this.$selected.find(`.js-${this.id}_option`), 'active', 'remove');
		}
	}
	selected_click_handler(event) {
		yalwa.basics.bem_modifier(this.$list, 'active', 'toggle');
		if (this.$list.find(`.js-${this.id}_option`).length) {
			yalwa.basics.bem_modifier(this.$list.find(`.js-${this.id}_option`), 'active', 'toggle');
		}
	}
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		const $selected = this.$selected.find(`.js-${this.id}_option`);
		$selected.prependTo(this.$list);
		$element.prependTo(this.$selected);
		this.close_all(event);
	}
	
	// Abstract method: should be implemented by subclasses
	add_events() {
		throw new Error("Method 'add_events()' must be implemented in the subclass.");
	}
}
